module.exports = {
  'font-default': '"Open Sans", sans-serif',

  'line-height-body': 1.67,
}
